(() => {
  if (window.BizJourneyReady) return;
  window.BizJourneyReady = true;
  const setLinks = () => {
    const browsing=new URL(location.href), scope=browsing.pathname.split('/')[2];
    const offerScopes=['all','e-deals','current-deals','under-25','big-savings','new-finds','limited-time-deals','prime-exclusive','amazon-best-sellers','best-sellers-on-sale','best-sellers-limited-time','best-sellers-prime-exclusive','best-sellers-big-savings'];
    const couponPage=browsing.pathname==='/pages/amazon-promo-codes';
    if(couponPage||(browsing.pathname.startsWith('/collections/')&&offerScopes.includes(scope))){
      document.querySelectorAll('[data-menu-group="categories"] a[data-menu-source]').forEach(link=>{
        const handle=link.dataset.menuSource, prefix=['skin-care','hair-care','bath-body'].includes(handle)?'bd-cat-':'bd-dept-';
        const url=new URL(browsing);['page','section_id','view'].forEach(key=>url.searchParams.delete(key));
        if(couponPage)url.searchParams.set('department',prefix+handle);
        else url.pathname='/collections/'+scope+'/'+prefix+handle;
        url.hash='OfferFilters';link.href=url.pathname+url.search+url.hash;
      });
    }
    document.querySelectorAll('[data-j-category]').forEach(link=>{const url=new URL(link.href,location.origin);url.search=location.search;['page','view','section_id'].forEach(k=>url.searchParams.delete(k));url.hash='OfferFilters';link.href=url.pathname+url.search+url.hash});
    document.querySelectorAll('[data-offer-shortcuts]').forEach(nav => {
      const current = new URL(location.href);
      nav.querySelectorAll('[data-offer-target],[data-offer-all]').forEach(link => {
        const url = new URL(link.href);
        url.search = current.search;
        ['page','section_id','view'].forEach(key => url.searchParams.delete(key));
        if (link.dataset.offerTarget) url.pathname = link.dataset.offerTarget + (nav.dataset.offerScope ? '/' + nav.dataset.offerScope : '');
        if (nav.dataset.offerBrand) url.searchParams.set('filter.p.vendor', nav.dataset.offerBrand);
        url.hash = document.querySelector('[data-bestseller-context]')?'best-seller-refinements':'collection-product-grid';
        link.href = url.pathname + url.search + url.hash;
      });
    });
    const bestContext=document.querySelector('[data-bestseller-context]');
    if(bestContext){
      const base=bestContext.dataset.bestBase;
      bestContext.querySelectorAll('[data-bs-department],.bj-crossshop a').forEach(link=>{
        const url=new URL(link.href,location.origin);
        const handle=url.pathname.split('/collections/')[1]?.split('/')[0];
        const known=['',...'home-cleaning,kitchen-dining,beauty-personal-care,tech-accessories,bed-bath,toys-games,baby-kids,pet-supplies,sports-outdoors,tools-home-improvement,office-school,patio-garden,health-household,fashion-accessories'.split(',').map(h=>'bd-dept-'+h),...'skin-care,hair-care,bath-body'.split(',').map(h=>'bd-cat-'+h)];
        const tag=link.hasAttribute('data-bs-department')?link.dataset.bsDepartment:'bd-dept-'+handle;
        if(!known.includes(tag))return;
        url.pathname=base+(tag?'/'+tag:'');url.search=location.search;url.searchParams.delete('page');
        
        url.hash='best-seller-refinements';link.href=url.pathname+url.search+url.hash;
      });
    }
    document.querySelectorAll('[data-j-navigation]').forEach(nav => {
      const current = new URL(location.href);
      const base = nav.dataset.jBase;
      nav.querySelectorAll('[data-j-budget],[data-j-sort],[data-j-department]').forEach(link => {
        const url = new URL(current);
        url.searchParams.delete('page'); url.searchParams.delete('section_id'); url.searchParams.delete('view');
        if (link.hasAttribute('data-j-budget')) {
          const active = current.searchParams.get('filter.v.price.lte') === '24.99';
          url.searchParams.delete('filter.v.price.gte');
          if (active) url.searchParams.delete('filter.v.price.lte'); else url.searchParams.set('filter.v.price.lte', '24.99');
          link.classList.toggle('is-active', active);
        }
        if (link.dataset.jSort) {
          url.searchParams.set('sort_by', link.dataset.jSort);
          link.classList.toggle('is-active', current.searchParams.get('sort_by') === link.dataset.jSort);
        }
        if (link.dataset.jDepartment) {
          const oldTags = current.pathname.slice(base.length).split('/').filter(Boolean).join('').split('+').filter(Boolean);
          const tag = link.dataset.jDepartment;
          const tags = oldTags.filter(t => !t.startsWith('bd-dept-') && !t.startsWith('bd-cat-'));
          if (!oldTags.includes(tag)) tags.push(tag);
          url.pathname = base + (tags.length ? '/' + tags.join('+') : '');
          
        }
        url.hash = document.querySelector('[data-bestseller-context]')?'best-seller-refinements':'collection-product-grid'; link.href = url.pathname + url.search + url.hash;
      });
    });
  };
  const moveGallery = () => {
    document.querySelectorAll('[data-j-open]').forEach(panel => {
      const root = panel.closest('[data-amazon-product]');
      if (!root) return;
      const target = root.querySelector(matchMedia('(min-width: 992px)').matches ? '[data-j-open-desktop]' : '[data-j-open-mobile]');
      if (target && panel.parentElement !== target) target.append(panel);
    });
    document.querySelectorAll('[data-j-gallery]').forEach(banner => {
      const root = banner.closest('[data-amazon-product]');
      if (!root) return;
      const target = root.querySelector(matchMedia('(min-width: 992px)').matches ? '[data-j-gallery-desktop]' : '[data-j-gallery-mobile]');
      if (target && banner.parentElement !== target) target.append(banner);
    });
  };
  const expireImages = () => document.querySelectorAll('img[data-j-expires]').forEach(img => {
    if (Number(img.dataset.jExpires) * 1000 <= Date.now()) img.remove();
  });
  const setupBestRows=()=>document.querySelectorAll('.bb-hub-row').forEach(row=>{
    if(row.dataset.ready)return;row.dataset.ready='true';
    const rail=row.querySelector('.bb-product-rail'),buttons=[...row.querySelectorAll('[data-bb-direction]')];
    const sync=()=>buttons.forEach(button=>{button.disabled=Number(button.dataset.bbDirection)<0?rail.scrollLeft<2:rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;});
    buttons.forEach(button=>button.addEventListener('click',()=>rail.scrollBy({left:Number(button.dataset.bbDirection)*rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
    rail.addEventListener('scroll',sync,{passive:true});new ResizeObserver(sync).observe(rail);sync();
  });
  const setupShortcutRows = () => document.querySelectorAll('[data-scroll-options]').forEach(rail => {
    if (rail.dataset.scrollReady) return;
    rail.dataset.scrollReady = 'true';
    const wrapper = document.createElement('div');
    wrapper.className = 'bd-scroll-options';
    rail.before(wrapper); wrapper.append(rail);
    if (!rail.id) rail.id = 'bd-options-' + [...document.querySelectorAll('[data-scroll-options]')].indexOf(rail);
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'bd-scroll-arrow bd-scroll-arrow--' + (direction < 0 ? 'previous' : 'next');
      button.setAttribute('aria-label', direction < 0 ? rail.dataset.scrollPrevious : rail.dataset.scrollNext);
      button.setAttribute('aria-controls', rail.id);
      button.innerHTML = direction < 0 ? "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"m14 6-6 6 6 6\"/></svg>" : "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"m10 6 6 6-6 6\"/></svg>";
      button.addEventListener('click', () => rail.scrollBy({left: direction * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
      wrapper.append(button); return button;
    });
    const sync = () => {
      const overflow = rail.scrollWidth > rail.clientWidth + 2;
      wrapper.classList.toggle('has-overflow', overflow);
      buttons.forEach((button, index) => { button.hidden = !overflow; button.disabled = index === 0 ? rail.scrollLeft <= 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2; });
    };
    rail.addEventListener('scroll', sync, {passive:true}); new ResizeObserver(sync).observe(rail); sync();
    const active = rail.querySelector('[aria-current],.is-active');
    if (active) rail.scrollLeft = Math.max(0, active.offsetLeft - rail.offsetLeft - rail.clientWidth / 3);
  });
  setLinks(); moveGallery(); expireImages(); setupBestRows(); setupShortcutRows();
  document.addEventListener('bizedeals:filters-changed',setLinks);
  document.addEventListener('click', event => {
    const link=event.target.closest('a');
    if(!link || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if(!link.closest('[data-bestseller-context]') && !link.matches('[data-offer-target],[data-offer-all]')) return;
    const target=new URL(link.href,location.origin);
    if(target.origin!==location.origin || !target.pathname.startsWith('/collections/')) return;
    if(target.pathname===location.pathname && target.search===location.search) return;
    event.preventDefault();event.stopImmediatePropagation();location.assign(target.href);
  },true);
  matchMedia('(min-width: 992px)').addEventListener('change', moveGallery);
  document.addEventListener('shopify:section:load', () => { setLinks(); moveGallery(); setupBestRows(); setupShortcutRows(); });
  setInterval(expireImages, 15000);
  document.addEventListener('change', event => {
    if (!event.target.matches('#collection-filters-form input, #select-sort-by')) return;
    if (!document.querySelector('[data-j-navigation],[data-bestseller-hub]')) return;
    event.stopImmediatePropagation();
    const url = new URL(location.href);
    [...url.searchParams.keys()].filter(key => key.startsWith('filter.')).forEach(key => url.searchParams.delete(key));
    const form = document.querySelector('#collection-filters-form');
    if (form) for (const [key, value] of new FormData(form)) {
      if (key.startsWith('filter.v.price.') && !event.target.closest('.range-slider') && !new URL(location.href).searchParams.has(key)) continue;
      if (value !== '') url.searchParams.append(key, value);
    }
    const sort = document.querySelector('#select-sort-by'); if (sort) url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page'); url.searchParams.delete('view'); url.hash = document.querySelector('[data-bestseller-context]')?'best-seller-refinements':'collection-product-grid';
    location.assign(url.href);
  }, true);
})();




